module.exports = __webpack_public_path__ + "static/media/RPI_Circle.f76314a2.png";